import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * interfaces
 */
import { IAppResponseModel } from '@network';
import { IUploadBatchDto, IUploadsApiService } from '../interfaces';
import { IDataTableRequest } from '../../data-table/interfaces';
import { IDataTableResponseModel } from '../../data-table/models/interfaces';

/**
 * consts
 */
import { UploadServiceConst } from '../consts';

/**
 * abstracts
 */
import { AbstractUploadApiService } from '../abstracts';

/**
 * HTTP calls of the uploads endpoints.
 * Only chooses the endpoint and the DTO type; the transport itself is
 * the base class's job.
 *
 * It is provided behind the UPLOADS_API token, so use the interface and
 * not this class.
 */
@Injectable()
export class UploadsApiService extends AbstractUploadApiService implements IUploadsApiService {

    /** @inheritdoc */
    public getDataTable(request: IDataTableRequest): Observable<IDataTableResponseModel<IUploadBatchDto>> {
        return this._postDataTable<IUploadBatchDto>(UploadServiceConst.LIST_ENDPOINT, request);
    }

    /** @inheritdoc */
    public getByBatchId(batchId: string): Observable<IAppResponseModel<IUploadBatchDto>> {
        return this._get<IUploadBatchDto>(UploadServiceConst.DETAILS_ENDPOINT(batchId));
    }

}
